import { AVATAR_COLORS } from '../../constants/avatars';

export const avatarBackground = (user: any) => {
  if (user?.color?.includes('gradient')) return user.color;

  const seed = [...(user?.username || 'D')].reduce(
    (sum, character) => sum + character.charCodeAt(0),
    0,
  );

  return AVATAR_COLORS[seed % AVATAR_COLORS.length];
};

export const displayCommunityName = (value = '') => {
  const parts = value.trim().split(/\s+/).filter(Boolean);
  const lastName = parts[parts.length - 1];

  if (parts.length <= 1) return parts[0] || '';
  return `${parts.slice(0, -1).join(' ')} ${lastName[0].toUpperCase()}.`;
};
